module.exports = __webpack_public_path__ + "static/coinbase_commerce_webhooks-173e1d476c37b6cd4b25e8673dfd4af5.png";